import { render } from "./SuppliersImportAssistant.vue?vue&type=template&id=333f01f6&scoped=true"
import script from "./SuppliersImportAssistant.vue?vue&type=script&lang=js"
export * from "./SuppliersImportAssistant.vue?vue&type=script&lang=js"

import "./SuppliersImportAssistant.vue?vue&type=style&index=0&id=333f01f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333f01f6"]])

export default __exports__